import { reactive } from 'vue'
import useConfirm from '../../../hooks/useConfirm'

export interface DropdownState {
  name: string
  title: string
  description: string | undefined
  id: number
  [K: string]: any
}

export enum DropdownType {
  ADMIN = 2,
  PREPARATION = 3
}

export default function useDropdown(
  callback: (item: DropdownState) => void,
  deleted: (id: string) => void
) {
  const dropdownList: DropdownState[] = reactive([
    {
      name: '课程管理员',
      title: '课程管理员',
      description: '(同课程负责人管理课程)',
      id: DropdownType.ADMIN
    },
    {
      name: '团队成员',
      title: '团队成员',
      description: '(可新建教案、引用教案)',
      id: DropdownType.PREPARATION
    }
  ])

  const formatTitle = (id: number) => {
    return dropdownList.filter(item => item.id === id)[0].title
  }

  const handleCommand = (command: DropdownState | string) => {
    if (typeof command === 'string') {
      return
    }
    callback(command)
  }

  const deleteItem = async (id: string) => {
    await useConfirm({
      headerTitle: '提示',
      tipTitle: '是否删除团队成员？',
      tipText: '删除后该团队成员将不在此团队中。'
    })
    deleted(id)
  }

  return {
    dropdownList,
    handleCommand,
    formatTitle,
    deleteItem
  }
}
